import React from 'react'
import styled from 'styled-components'
import { useCongress } from '../../congress/hooks'
import LayoutContainer from './Container'
import Button from '../Button'

export default function Title ({ children }) {

  return (
   <Container>
     {children}
   </Container>
  )
}

const Container = styled.h3`
  font-size: 3rem;
  font-weight: 300;
  margin-bottom: 2rem;
`